<script>
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap, withLatestFrom, startWith } from 'rxjs/operators';
  import _ from 'lodash'

  export let name = name
  export let description = description
</script>

<div class='pt2 white f6'>
  <div class='pl3 pt1 fw7'>{name}</div>
  <div class='pl3 pt1'>{description}</div>
</div>


<style>
</style>